import React from 'react'

function PageNotFound() {
  return (
    <div className=' w-full flex justify-center items-center'>
      <p className='text-xl mt-10'> Page Not Found </p>
     
      </div>
  )
}

export default PageNotFound